import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { Prompt } from 'react-router';
import CheckoutProfileSettings from './containers/CheckoutProfileSettings/CheckoutProfileSettings';
import CheckoutProfiles from './containers/CheckoutProfiles/CheckoutProfiles';
import paymentCheckoutStore from './store/paymentCheckoutStore';
import { SCREENS } from '~/constants/screens';
import { appStore } from '~/mobx/appStore';
import { localeStore } from '~/mobx/localesStore';
import { LoadingStatus } from '~/types/main';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';

const PaymentCheckout: FC = observer(() => {
  useEffect(() => {
    paymentCheckoutStore.init();
  }, []);

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title={localeStore.t('payment-checkout')} path={SCREENS.SETTINGS_INTEGRATIONS()} />
      </Headers>

      <div className="d-flex flex-row mt-4">
        {appStore.isAddonsAvailable.franchise ? <CheckoutProfiles /> : null}
        <CheckoutProfileSettings />
      </div>

      <LoadingOverlay visible={paymentCheckoutStore.loadingStatus === LoadingStatus.Loading} refreshing />
      <Prompt when={paymentCheckoutStore.isDataEdited} message={getPromptProps()} />
    </div>
  );
});

export default PaymentCheckout;
